import { useContext } from 'react';
import { Buttons, FlexContainer, Icon, ModalContext, Text } from '@taxdown/piccolo-web';
import { locizeNS } from 'Services/i18n';
import useTranslation from 'Hooks/useTranslation';
import { ShareModal } from 'Components/Modal/components';
import * as Styled from './styles';

const MgmSteps = ({ havePreviousYears }: { havePreviousYears: boolean }): JSX.Element => {
  const { t } = useTranslation(locizeNS.FILING);
  const { showModal } = useContext(ModalContext);
  const handleClick = (): void => {
    showModal({
      comp: <ShareModal isFiling={false} />,
    });
  };
  return (
    <FlexContainer direction="column" fullWidth gap="dimension_16">
      <Text type="headline" size="XS_L_S" color="dark" align="center">
        {t('Mgm.steps.title')}
      </Text>
      <Text type="paragraphs" size="M_L_M" color="cold" align="center">
        {t('Mgm.steps.subtitle')}
      </Text>
      <Styled.StepsContainer align="center" gap="dimension_24">
        <Icon icon="IconNumber1S" color="cold" />
        <Text type="paragraphs" size="S_L_M" color="dark">
          {t('Mgm.steps.one')}
        </Text>
      </Styled.StepsContainer>
      <Styled.StepsContainer align="center" gap="dimension_24">
        <Icon icon="IconNumber2S" color="cold" />
        <Text type="paragraphs" size="S_L_M" color="dark">
          {t('Mgm.steps.two')}
        </Text>
      </Styled.StepsContainer>
      <Styled.StepsContainer align="center" gap="dimension_24">
        <Icon icon="IconNumber3S" color="cold" />
        <Text type="paragraphs" size="S_L_M" color="dark">
          {t('Mgm.steps.three')}
        </Text>
      </Styled.StepsContainer>
      {havePreviousYears && (
        <FlexContainer fullWidth justify="center" align="center">
          <Buttons.Classic
            size="s"
            mode="cold"
            label={t('Mgm.steps.button')}
            onClick={handleClick}
          />
        </FlexContainer>
      )}
    </FlexContainer>
  );
};
export default MgmSteps;
